import { render, staticRenderFns } from "./Supplying.vue?vue&type=template&id=34019b36&v-slot%3Ano-data=true"
import script from "./Supplying.vue?vue&type=script&lang=js"
export * from "./Supplying.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports